module.exports = __webpack_public_path__ + "static/media/partner-story-ad2.7acef4bb.jpg";